export default {
  about: 'Tentang',
  addOns: 'Tambahan',
  agenda: 'Agenda',
  all: 'Semua',
  browse: 'Jelajahi',
  buyTickets: 'Beli tiket',
  countSelected: '{{count}} dipilih',
  included: 'Termasuk',
  joining: 'Bergabung',
  joinWaitlist: 'Gabung Daftar Tunggu',
  menu: 'Menu',
  noDatesAvailable: 'Tidak ada tanggal tersedia',
  salesEnded: 'Penjualan berakhir',
  schedule: 'Jadwal',
  seeMoreDates: 'Lihat lebih banyak tanggal',
  soldOut: 'Habis terjual',
  tickets: 'Tiket',
  viewMore: 'Lihat lebih banyak',
  viewLess: 'Lihat lebih sedikit',
  location: 'Lokasi',
  time: 'Waktu',
  at: 'pada',
  noTimesAvailableOnThisDateFotThisPartySize:
    'Tidak ada waktu tersedia pada tanggal ini untuk ukuran rombongan ini',
  availableTimes: 'Waktu tersedia',
  waitlist: 'Daftar Tunggu',
  continue: 'Lanjutkan',
  ticketsAreNoLongerAvailable: 'Tiket tidak lagi tersedia.',
  checkOutOutOtherExperiences: 'Lihat pengalaman kami yang lain!',
  viewExperiences: 'Lihat pengalaman',
  from: 'dari',
  cancellationPolicy: 'Kebijakan pembatalan',
  rsvp: 'RSVP',
  nights: 'malam',
  request: 'Permintaan',
  arrival: 'Kedatangan',
  departure: 'Keberangkatan',
};
